<div class="grid">
  <div class="col-12 p-2 text-xl text-left font-['Poppins']"
    style="color: cadetblue; display: flex; justify-content: space-between; align-items: center;">
    <div style="display: flex; align-items: center; gap: 10px;">
      <span class="text-xl text-left font-['Poppins'] mr-3" style="color: cadetblue;">Ultime 5 pratiche del bando 1 dichiarate KO</span>
      <div class="p-2" style="border-radius: 10px; background-color: #619496; display: flex; justify-content: center; align-items: center; height: 100%;">
        <span 
          class="text-right font-['Poppins']" 
          style="color: #f9f9f9; font-size: small;"
          
        >Totali: <span class="font-semibold" style="font-size: medium;">{{stats.bando1KO}}</span></span>
      </div>
  </div>
     <!--  <p-tag icon="pi pi-check-circle" severity="success" class="ml-3" value="TOTALI: {{stats.bando1KO}}"></p-tag> -->
      
    </div>
    
  </div>
  
  <div class="col-12 p-2 text-xl text-left font-['Poppins']">
    <p-table styleClass="p-datatable-sm" 
    [selectionPageOnly]="true" [rowHover]="true" [rows]="5" [showCurrentPageReport]="true"
    [paginator]="false" [loading]="isLoading" [value]="praticheBando1KO" dataKey="id" [(selection)]="selectedPraticaBando1KO">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="cui" style="font-size: 10px; width: 20%;">
          CUI
        </th>
        <th  pSortableColumn="denominazione" style="font-size: 10px; width: 17%;">
          Scuola
        </th>
        <th class="text-center font-['Poppins']" style="font-size: 10px; width: 15%;">
          Tipo
       </th>
        <th class="text-center font-['Poppins']" style="font-size: 10px;width: 15%;">
          Impresa
        </th>
        <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
            Lotto
        </th>
        <th class="text-center font-['Poppins']" style="font-size: 10px; width: 15%;">
          ODA
        </th >
        <th class="text-center font-['Poppins']" style="font-size: 10px; width: 15%;">
          Data dichiarazione KO
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td class="text-left" style="width: 10px;">
          <span class="text-uppercase font-semibold font-['Poppins']" style="font-size: 9.5px; "
          [pTooltip]="row.codiceMiur"
          tooltipPosition="top"
          >{{row.cui}}</span> 
        </td>
      
        <td > 
          <span class="text-uppercase font-['Poppins']" style="font-weight: 500;font-size: 9px; "
            [pTooltip]="row.indirizzo+' - ' + row.comune.toUpperCase()"
            tooltipPosition="top"
            >{{row.denominazione}}</span> 
        </td>
        <td *ngIf="row.tipoSede === row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 9px;">{{getTipoSedeAbbreviata(row.tipoSede)}}</span> </td>
        <td *ngIf="row.tipoSede !== row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 9px;">{{getTipoSedeAbbreviata(row.tipoSede)}} ({{getTipoSedeAbbreviata(row.tipoSedeEffettiva)}})</span> </td>
        <td class="text-center font-['Poppins']"> 
          <p-tag
                  [value]="row.azienda | uppercase"
                  [style]="{
                    'background-color': '#326F6F' ,
                    'color': '#ffffff' ,
                    'border-radius': '6px',
                    'padding': '.25em .5rem',
                    'font-weight': '700',
                    'font-size': '9px',
                    'letter-spacing': '.3px;',
                    'cursor': 'pointer',
                  }"
                   (click)="filtraPerAzienda(row.azienda)"
                   [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per azienda '+ row.azienda"
                    tooltipPosition="top"
              ></p-tag>
         </td>
         <td class="text-center font-['Poppins']"> 
          <p-tag [value]="row.lotto | uppercase"
                [style]="{
                  'background-color': '#EBC66B' ,
                  'color': '#ffffff' ,
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '8px',
                  'letter-spacing': '.3px;',
                  'cursor': 'pointer',
                }"
                    class="mr-1"
                    (click)="filtraPerLotto(row.lotto)"
                    [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per lotto '+row.lotto"
                    tooltipPosition="top"
          ></p-tag>
        </td>
        <td class="text-center font-['Poppins']"> 
          <p-tag *ngIf="row.numeroOda" [value]="row.numeroOda"
                [style]="{
                  'background-color': '#78C0E0' ,
                  'color': '#ffffff' ,
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '9px',
                  'letter-spacing': '.3px;',
                  'cursor': 'pointer',
                }"
                    class="mr-1"
                    (click)="filtraPerOda(row.numeroOda)"
                    [pTooltip]="filterIsSet?'ELimina filtro':'Filtra su ODA #'+row.numeroOda"
                    tooltipPosition="top"
          ></p-tag>
        </td>
        <td class="text-center font-['Poppins']">
          <span *ngIf="row.dataUltimaModificaFase1" 
          class="text-center text-uppercase font-semibold font-['Poppins']" 
          style="font-size: 11px; " 
          [pTooltip]="row.noteSopralluogo"
           tooltipPosition="top"
                    >{{utilService.formattaDataDaTimestampFirestore(row.dataUltimaModificaFase1)}}
        </span>

        </td>
      </tr>
    </ng-template>
    </p-table>
  </div>
  <div class="col-12 border-bottom-1 opacity-50 "></div>

  <div class="col-12 mt-2 p-2 text-xl text-left font-['Poppins']"
    style="color: cornflowerblue; display: flex; justify-content: space-between; align-items: center;">
    <div style="display: flex; align-items: center; gap: 10px;">

      <span class="text-xl text-left font-['Poppins'] mr-3" style="color: cornflowerblue;">Ultime 5 pratiche del bando 2 dichiarate KO</span>
      <div class="p-2" style="border-radius: 10px; background-color: cornflowerblue; display: flex; justify-content: center; align-items: center; height: 100%;">
        <span 
          class="text-right font-['Poppins']" 
          style="color: #f9f9f9; font-size: small;"
          
        >Totali: <span class="font-semibold" style="font-size: medium;">{{stats.bando2KO}}</span></span>
      </div>
      
    </div>
   
  </div>
  <div class="col-12 p-2 text-xl text-left font-['Poppins']">
    <p-table styleClass="p-datatable-sm" 
    [selectionPageOnly]="true" [rowHover]="true" [rows]="5" [showCurrentPageReport]="true"
    [paginator]="false"  [loading]="isLoading" [value]="praticheBando2KO" dataKey="id" [(selection)]="selectedPraticaBando2KO">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="cui" style="font-size: 10px; width: 20%;">
          CUI
        </th>
        <th  pSortableColumn="denominazione" style="font-size: 10px; width: 17%;">
          Scuola
        </th>
        <th class="text-center font-['Poppins']" style="font-size: 10px; width: 15%;">
          Tipo
       </th>
        <th class="text-center font-['Poppins']" style="font-size: 10px;width: 15%;">
          Impresa
        </th>
        <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
            Lotto
        </th>
        <th class="text-center font-['Poppins']" style="font-size: 10px; width: 15%;">
          ODA
        </th >
        <th class="text-center font-['Poppins']" style="font-size: 10px; width: 15%;">
          Data dichiarazione KO
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td class="text-left" style="width: 10px;">
          <span class="text-uppercase font-semibold font-['Poppins']" style="font-size: 9.5px; "
          [pTooltip]="row.codiceMiur"
          tooltipPosition="top"
          >{{row.cui}}</span> 
        </td>
      
        <td > 
          <span class="text-uppercase font-['Poppins']" style="font-weight: 500;font-size: 9px; "
            [pTooltip]="row.indirizzo+' - ' + row.comune.toUpperCase()"
            tooltipPosition="top"
            >{{row.denominazione}}</span> 
        </td>
        <td *ngIf="row.tipoSede === row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 9px;">{{getTipoSedeAbbreviata(row.tipoSede)}}</span> </td>
        <td *ngIf="row.tipoSede !== row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 9px;">{{getTipoSedeAbbreviata(row.tipoSede)}} ({{getTipoSedeAbbreviata(row.tipoSedeEffettiva)}})</span> </td>
        <td class="text-center font-['Poppins']"> 
          <p-tag
                  [value]="row.azienda | uppercase"
                  [style]="{
                    'background-color': '#326F6F' ,
                    'color': '#ffffff' ,
                    'border-radius': '6px',
                    'padding': '.25em .5rem',
                    'font-weight': '700',
                    'font-size': '9px',
                    'letter-spacing': '.3px;',
                    'cursor': 'pointer',
                  }"
                   (click)="filtraPerAzienda(row.azienda)"
                   [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per azienda '+ row.azienda"
                    tooltipPosition="top"
              ></p-tag>
         </td>
         <td class="text-center font-['Poppins']"> 
          <p-tag [value]="row.lotto | uppercase"
                [style]="{
                  'background-color': '#EBC66B' ,
                  'color': '#ffffff' ,
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '8px',
                  'letter-spacing': '.3px;',
                  'cursor': 'pointer',
                }"
                    class="mr-1"
                    (click)="filtraPerLotto(row.lotto)"
                    [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per lotto '+row.lotto"
                    tooltipPosition="top"
          ></p-tag>
        </td>
        <td class="text-center font-['Poppins']"> 
          <p-tag *ngIf="row.numeroOda" [value]="row.numeroOda"
                [style]="{
                  'background-color': '#78C0E0' ,
                  'color': '#ffffff' ,
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '9px',
                  'letter-spacing': '.3px;',
                  'cursor': 'pointer',
                }"
                    class="mr-1"
                    (click)="filtraPerOda(row.numeroOda)"
                    [pTooltip]="filterIsSet?'ELimina filtro':'Filtra su ODA #'+row.numeroOda"
                    tooltipPosition="top"
          ></p-tag>
        </td>
        <td class="text-center font-['Poppins']">
          <span *ngIf="row.dataUltimaModificaFase1" 
          class="text-center text-uppercase font-semibold font-['Poppins']" 
          style="font-size: 11px; " 
          [pTooltip]="row.noteSopralluogo"
           tooltipPosition="top"
                    >{{utilService.formattaDataDaTimestampFirestore(row.dataUltimaModificaFase1)}}
        </span>

        </td>
      </tr>
    </ng-template>
    </p-table>


   
   
</div>